<template>
  <div class="product-list-detail">
    <h3 style="background: #13ce66;color: #fff">已选货品</h3>
    <table class="table">
      <thead>
      <tr>
        <th style="width: 240px">货品</th>
        <th>规格</th>
        <template v-if="isExistBatchNumber">
          <th>批号</th>
          <th>有效期</th>
        </template>
        <th style="width: 70px">单价</th>
        <th style="width: 70px">数量</th>
        <th>金额</th>
        <th style="width: 60px">操作</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="product in goodsList" :key="product.batchNumberId">
        <td>
          <span>{{product.goodsName}}</span>
          <div class="f-grey">
             货品编号：{{product.code}}
          </div>
          <div class="f-grey" v-show="product.factoryName">
            生产单位：{{product.factoryName}}
          </div>
          <div class="f-grey" v-show="product.supplyManufacturers">
            供货单位：{{product.supplyManufacturers}}
          </div>
        </td>
        <td>
          <div style="max-height: 120px;overflow-y: auto">{{ product.specifications }}</div>
        </td>
        <template v-if="isExistBatchNumber">
          <td>
            <span>{{ product.batchNumber }}</span>
          </td>
          <td>
            <span>{{ product.expirationDate | date }}</span>
          </td>
        </template>
        <td class="ar">
          <span v-show="product.unitPrice">¥</span>{{product.unitPrice | formatMoney}}
        </td>
        <td class="ar">{{product.amount}} <span v-show="product.measurementUnit">（<dict
          :dict-group="'measurementUnit'"
          :dict-key="product.measurementUnit"></dict>）</span>
        </td>
        <td class="ar">
          <span>¥</span>{{ product.amount * product.unitPrice | formatMoney }}
        </td>
        <td>
          <div>
            <a href="#" @click.prevent="editItem(product)"><i class="el-icon-t-edit"></i> 编辑</a>
          </div>
          <div>
            <a href="#" @click.prevent="deleteItem(product)"><i class="el-icon-t-delete"></i> 删除</a>
          </div>
        </td>
      </tr>
      <tr>
        <td :colspan="isExistBatchNumber ? 6 : 4"></td>
        <td colspan="2">
          <span v-show="totalMoney">
            <span style="color: #333;font-weight: 700">合计：</span>
            <span>¥{{ totalMoney | formatMoney }}</span>
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    props: {
      goodsList: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      totalMoney: function () {
        let totalMoney = 0.00;
        this.goodsList.forEach(item => {
          totalMoney += item.amount * item.unitPrice;
        });
        return totalMoney;
      },
      isExistBatchNumber () {
        return this.goodsList.some(s => s.batchNumber);
      }
    },
    methods: {
      editItem (item) {
        this.$emit('editItem', item)
      },
      deleteItem (item) {
        this.$emit('deleteItem', item)
      }
    }
  }
</script>
